/*
 * Aynı desen ailesi (snippets/hs-pattern-family.liquid).
 *  - Fiyat altı işaret: sayfadan çıkmadan satın alma seçeneklerine kaydırır.
 *  - Kartlar: müşterinin beden profili varsa (window.hsSizeAdvisor) her ürün kendi kalıp kuralıyla
 *    hesaplanır; "M bedeninizde var / son 1 / yok" yazılır, bedeni olmayanlar listenin sonuna iner.
 *  - Ölçüm: hs_pf_view, hs_pf_click (hs3Track varsa onunla).
 */
(function () {
  if (window.__hsPatternFamily) return;
  window.__hsPatternFamily = true;

  function track(name, data) {
    if (window.hs3Track) return window.hs3Track(name, data || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function handleOf(a) { try { return new URL(a.href).pathname.split('/products/')[1] || ''; } catch (e) { return ''; } }

  document.addEventListener('click', function (e) {
    var jump = e.target.closest && e.target.closest('[data-hs-pf-jump]');
    if (jump) {
      var to = document.getElementById('hs-pattern-family') || document.getElementById('hs3-options');
      track('hs_pf_click', { place: 'beacon' });
      if (to) {
        e.preventDefault();
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        to.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
      return;
    }
    var card = e.target.closest && e.target.closest('[data-hs-pf-card]');
    if (card) track('hs_pf_click', { place: 'shelf', handle: handleOf(card), fit: card.dataset.hsPfState || '' });
  }, true);

  function parse(s) {
    var out = {};
    (s || '').split(',').forEach(function (p) {
      var i = p.lastIndexOf(':');
      if (i > 0) { var k = p.slice(0, i); out[k] = Math.max(out[k] || 0, Number(p.slice(i + 1)) || 0); }
    });
    return out;
  }

  function mark() {
    var api = window.hsSizeAdvisor;
    var root = document.querySelector('[data-hs-pf]');
    if (!root || !api) return;
    var marked = 0;
    var panel = root.hasAttribute('data-hs-pfp');
    root.querySelectorAll('[data-hs-pf-card]').forEach(function (card) {
      var fit = card.querySelector('[data-hs-pf-fit]');
      var sizes = parse(card.dataset.hsPfSizes);
      var gr = (card.dataset.hsPfGroup || '|').split('|');
      var values = Object.keys(sizes);
      var r = gr[1] && values.length > 1 ? api.suggest(gr[0], gr[1], values) : null;
      card.classList.remove('is-nofit');
      card.dataset.hsPfState = '';
      if (!r || !fit) { if (fit) fit.hidden = true; return; }
      var q = sizes[r.size] || 0;
      var state = q > 1 ? 'ok' : q === 1 ? 'last' : 'none';
      fit.textContent = (panel ? '' : ' · ') + r.size + (state === 'ok' ? ' bedeniniz var' : state === 'last' ? ' bedeniniz son 1' : ' bedeniniz tükendi');
      fit.dataset.state = state;
      fit.hidden = false;
      card.dataset.hsPfState = state;
      if (state === 'none') card.classList.add('is-nofit');
      marked++;
    });
    root.querySelectorAll('[data-hs-pf-list]').forEach(function (list) {
      list.querySelectorAll('[data-hs-pf-card].is-nofit').forEach(function (c) { list.appendChild(c); });
    });
    var note = root.querySelector('[data-hs-pf-note]');
    if (note) {
      note.hidden = !marked;
      note.textContent = marked ? 'Bedenler her ürünün kendi kalıbına göre, sizin ölçünüzle hesaplandı.' : '';
    }
  }

  function seen() {
    var root = document.querySelector('[data-hs-pf], [data-hs-pf-beacon]');
    if (!root || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        track('hs_pf_view', { place: x.target.hasAttribute('data-hs-pf') ? 'shelf' : 'beacon' });
        io.unobserve(x.target);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-hs-pf], [data-hs-pf-beacon]').forEach(function (el) { io.observe(el); });
  }

  // Desen paneli: ekrana girince zemin, başlık ve kartlar sırayla gelir; alttaki ince çizgi kaydırmayı izler.
  function panel() {
    var el = document.querySelector('[data-hs-pfp]');
    if (!el || el.dataset.hsPfpBound) return;
    el.dataset.hsPfpBound = '1';
    var cards = el.querySelectorAll('.hs-pfp__card');
    cards.forEach(function (c, i) { c.style.setProperty('--i', Math.min(i, 6)); });
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var below = el.getBoundingClientRect().top > window.innerHeight * 0.9;
    if (!still && below && 'IntersectionObserver' in window) {
      el.dataset.hsPfpState = 'ready';
      var io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { el.dataset.hsPfpState = 'in'; io.disconnect(); }
      }, { threshold: 0.2 });
      io.observe(el);
    } else if (!still) {
      el.dataset.hsPfpState = 'in';
    }
    var rail = el.querySelector('.hs-pfp__rail'), bar = el.querySelector('[data-hs-pfp-bar]');
    if (rail && bar) {
      var draw = function () {
        var w = rail.scrollWidth ? Math.min(1, rail.clientWidth / rail.scrollWidth) : 1;
        var x = rail.scrollWidth ? rail.scrollLeft / rail.scrollWidth : 0;
        bar.style.width = (w * 100) + '%';
        bar.style.transform = 'translateX(' + (w ? (x / w) * 100 : 0) + '%)';
        bar.parentNode.hidden = w >= 0.99;
      };
      rail.addEventListener('scroll', draw, { passive: true });
      window.addEventListener('resize', draw);
      draw();
    }
  }

  document.addEventListener('hs:size-profile', mark);
  function start() { panel(); mark(); seen(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', mark);
})();
